import React, { useState } from 'react';
import { Shield, Zap, BarChart, CreditCard, ExternalLink, Check, Grid } from 'lucide-react';
const apps = [{
  id: 'sentinel',
  name: 'AVA Sentinel',
  desc: 'Real-time server monitoring and DDoS protection.',
  icon: Shield,
  color: 'text-indigo-600',
  bg: 'bg-indigo-50'
}, {
  id: 'finance',
  name: 'AVA Finance',
  desc: 'Automated tax calculation and multi-currency invoicing.',
  icon: CreditCard,
  color: 'text-emerald-600',
  bg: 'bg-emerald-50'
}, {
  id: 'crm',
  name: 'AVA CRM',
  desc: 'White-labeled customer management and support portal.',
  icon: BarChart,
  color: 'text-purple-600',
  bg: 'bg-purple-50'
}];
export function AppCenter() {
  const [enabledApps, setEnabledApps] = useState<string[]>(['sentinel']);
  const toggleApp = (id: string) => {
    setEnabledApps(prev => prev.includes(id) ? prev.filter(a => a !== id) : [...prev, id]);
  };
  return <div className="space-y-8 max-w-[1600px] mx-auto" data-id="element-796">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-797">
        <div data-id="element-798">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-799">
            AVA Tool Marketplace
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-800">
            Enable specialized tools for your white-label clients.
          </p>
        </div>
        <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg" data-id="element-801">
          <Grid size={24} data-id="element-802" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-803">
        {apps.map(app => {
        const isEnabled = enabledApps.includes(app.id);
        const Icon = app.icon;
        return <div key={app.id} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm flex flex-col justify-between group" data-id="element-804">
              <div className="space-y-4" data-id="element-805">
                <div className="flex items-start justify-between" data-id="element-806">
                  <div className={`p-3 rounded-lg ${app.bg} ${app.color}`} data-id="element-807">
                    <Icon size={24} data-id="element-808" />
                  </div>
                  <div onClick={() => toggleApp(app.id)} className={`w-12 h-6 rounded-full relative cursor-pointer transition-all duration-200 ${isEnabled ? 'bg-indigo-600' : 'bg-gray-200'}`} data-id="element-809">
                    <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all duration-200 ${isEnabled ? 'left-7' : 'left-1'}`} data-id="element-810"></div>
                  </div>
                </div>
                <div data-id="element-811">
                  <h4 className="font-bold text-slate-900" data-id="element-812">{app.name}</h4>
                  <p className="text-xs text-gray-500 font-medium leading-relaxed mt-1" data-id="element-813">
                    {app.desc}
                  </p>
                </div>
              </div>
              <div className="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-814">
                <span className={`text-[10px] font-bold uppercase tracking-widest ${isEnabled ? 'text-indigo-600' : 'text-gray-400'}`} data-id="element-815">
                  {isEnabled ? 'Enabled for Clients' : 'Disabled'}
                </span>
                <button className="text-gray-400 hover:text-indigo-600 transition-colors" data-id="element-816">
                  <ExternalLink size={16} data-id="element-817" />
                </button>
              </div>
            </div>;
      })}
      </div>
    </div>;
}